// extracted by mini-css-extract-plugin
export default {"passwordButton":"auth__passwordButton__JPP_HE","iconContainer":"auth__iconContainer__pIkXHa","icon":"auth__icon__anKrkN"};